import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter, booleanAttribute } from '@angular/core';
import { RouterModule } from '@angular/router';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

import { InfoIconComponent, RequiredIconComponent, StatusIconComponent } from '@app/root/app/shared';
import { StatusTypes } from '@app/shared/components/status-icon/status-icon.component';
import { DocumentActionsComponent } from '@app/shared/components/document-actions/document-actions.component';

import { TeamDocumentViewModel } from '@app/shared/models/team.models';
import { EntityDocumentViewModel } from '@app/shared/models/document.models';
import { DocumentStatusCodes, DocumentStatusCardColors } from '@app/constants';

@Component({
	selector: 'app-document-card',
	templateUrl: './document-card.component.html',
	styleUrl: './document-card.component.scss',
	standalone: true,
	imports: [
		CommonModule, RouterModule, FontAwesomeModule, NgbTooltipModule,
		RequiredIconComponent, InfoIconComponent, StatusIconComponent, DocumentActionsComponent
	]
})
export class DocumentCardComponent {
	@Input({ required: true }) document!: TeamDocumentViewModel;
	@Input() onInstructionsFileBytesFetched?: (file: Blob, document: EntityDocumentViewModel) => Promise<Blob>;

	@Input() titleType: 'doc' | 'entity' | 'status' = 'doc';
	@Input() showUpload = true;
	@Input() uploadLabel = '';
	@Input({ transform: booleanAttribute }) showInlineStatusNotes = false;

	@Input() buttonSizeClass = 'btn-xs';
	@Input() cardless = false;

	@Input() instructionsFileBytesFetched?: (file: Blob, document: EntityDocumentViewModel) => Promise<Blob>;

	// TODO: CHANGE TO EntityDocumentViewModel ONCE API RETURNS THAT
	@Output() uploaded = new EventEmitter<number>();
	@Output() approved = new EventEmitter<EntityDocumentViewModel>();
	@Output() rejected = new EventEmitter<EntityDocumentViewModel>();

	// constants
	DocumentStatusCodes = DocumentStatusCodes;
	DocumentStatusCardColors = DocumentStatusCardColors;
	StatusTypes = StatusTypes;

	onFileFetched = async (file: Blob): Promise<Blob> => {
		if (this.instructionsFileBytesFetched) {
			return await this.instructionsFileBytesFetched(file, this.document);
		}
		return file;
	};
}
